import { Observable, of } from 'rxjs'
import {
  catchError,
  filter,
  switchMap,
  take,
  tap,
  timeout
} from 'rxjs/operators'
import { AppState } from 'src/app/core/core.state'

import { Component, OnInit } from '@angular/core'
import { UntypedFormGroup } from '@angular/forms'
import { Store } from '@ngrx/store'

import { RolePermissions } from '../role-permissions'
import { rolePermissionsActions } from '../role-permission.actions'
import { rolePermissionsSelectors } from '../role-permissions.selectors'
import { NotificationService } from 'src/app/core/notification.service'
import { Actions, ofType } from '@ngrx/effects'
import { ActivatedRoute } from '@angular/router'
import { RolePermissionsService } from '../role-permissions.service'

@Component({
  selector: 'role-permission-general-tab',
  templateUrl: './show.component.html',
  styleUrls: ['./show.component.scss']
})
export class RolePermissionsGeneralTabComponent implements OnInit {
  public rolePermissions$: Observable<RolePermissions>
  public rolePermissionId$: Observable<number>
  public form: UntypedFormGroup

  constructor(
    private actions$: Actions,
    private notificationService: NotificationService,
    private store: Store<AppState>,
    private rolePermissionsService: RolePermissionsService,
    private activeRoute: ActivatedRoute
  ) {}

  ngOnInit() {
    if (this.rolePermissionsService.showModal) {
      this.activeRoute.params.pipe(take(1)).subscribe((params) => {
        if (params.hasOwnProperty('rolePermissionsId')) {
          this.rolePermissionId$ = of(Number(params['rolePermissionsId']))
        }
      })
    } else {
      this.rolePermissionId$ = this.store
        .select(rolePermissionsSelectors.selectIdRouteParam)
        .pipe(filter((id) => Boolean(id)))
    }

    this.rolePermissions$ = this.rolePermissionId$.pipe(
      switchMap((rolePermissionId) =>
        this.store.select(rolePermissionsSelectors.selectById, rolePermissionId)
      )
    )
  }

  public onSubmit(form): void {
    this.rolePermissionId$.pipe(take(1)).subscribe((rolePermissionId) =>
      this.store.dispatch(
        rolePermissionsActions.updateOneById({
          id: rolePermissionId,
          params: {
            ...form[0],
            id: parseInt(rolePermissionId.toString()),
            roleId: form[0].roleId,
            productId: form[0].productId,
            validFrom: form[0].validFrom,
            validTill: form[0].validTill
          }
        })
      )
    )

    this.actions$
      .pipe(
        ofType(rolePermissionsActions.upsertMany),
        take(1),
        timeout(1000),
        catchError((error) => of(null))
      )
      .subscribe((action) =>
        action
          ? this.notificationService.emit('alerts.success', 'success')
          : null
      )
  }
}
